import React from 'react'
import Header from "../../components/header/index";
// import TermConditionContent from './termsconditioncontent/termConditionContent';
import Footer from "../../components/footer";
import PolicyContent from './policyContent/policyContent';

const policies = () => {
  return (
    <div className="main">
    <Header />
    <PolicyContent />
    {/* <TermConditionContent /> */}
    <Footer />
</div>
  )
}

export default policies